// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".conteneur-contenu[data-v-5a9a080d]{max-width:750px;margin:64px auto}@media(max-width:768px){.conteneur-contenu[data-v-5a9a080d]{max-width:none;margin:64px 16px}}.sous_contenu[data-v-5a9a080d]{margin:32px 64px 64px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
